<template>

    <div class="question__body" :class="{ '-locked': disabled }">
        <question-title :title="title" :sub-title="subTitle" :hashelp="hashelp" :uuid="uuid" :question-index="questionIndex"></question-title>

        <table class="matrix-2d matrix-dynamic__table">
            <colgroup>
                <col class="matrix-w-530">
                <col class="matrix-w-220" :span="columns.length">
                <col class="matrix-w-20">
            </colgroup>
            <thead>
                <matrix-column-group :column-group="columnGroup" :span="columns.length" :first-col-class="'matrix-w-530'"></matrix-column-group>
                <tr>
                    <th class="matrix__header-title matrix-2d__header-title matrix-w-530" v-html="headerTitle"></th>
                    <th v-for="(column, index) of columns" :key="index" class="matrix-w-220" :class="{ 'col-locked': isColumnDisabled(column.value) }">
                        <span v-once v-html="column.label"></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <matrix-2d-inclusive-dynamic-rows-row v-for="(choice, index) of rows" :key="choice.id"
                    :question-index="questionIndex"
                    :choice="choice"
                    :row="choice"
                    :columns="columns"
                    :uukey="uukey"
                    :triggers="triggers"
                    :answer="answer.answer"
                    :disabled="disabled"
                    :disabled-columns="disabledColumns"
                    :read-only="readOnly"
                    :text-placeholder="textPlaceholder"
                    :delete-button-title="deleteButtonTitle"
                ></matrix-2d-inclusive-dynamic-rows-row>
                <tr>
                    <td class="matrix-w-530">
                        <button v-if="!readOnly" type="button" class="btn btn-link" :disabled="disabled" :tabindex="questionIndex" @click.prevent.stop="addRow"><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span> {{ addButtonTitle }}</button>
                        <a v-if="readOnly" name="add-row" class="btn btn-link" disabled><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span> {{ addButtonTitle }}</a>
                    </td>
                    <td :colspan="columns.length + 1"> </td>
                </tr>
            </tbody>

        </table>
        <question-tip :questionTip="questionTip"></question-tip>
    </div>

</template>


<script>
import { reduce, isObject, has, forEach, isNil } from 'lodash';
import { questionMixin } from './mixins/question-mixin';
import { matrixMixin } from './mixins/matrix-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';
import { matrixRowSourcedMixin } from './mixins/matrix-row-sourced-mixin';
import { DISABLED_VALUE } from '../../constants';
import { mapState } from 'vuex';

export default {
    name: 'matrix-2d-inclusive-dynamic-rows',

    mixins:[
        questionMixin,
        matrixMixin,
        matrixColumnsMixin,
        matrixRowSourcedMixin,
    ],

    props:{
        textPlaceholder: {
            type: String,
            default: 'Indiquez le nom'
        },
        addButtonTitle: {
            type: String,
            default: 'Ajouter un item'
        },
        deleteButtonTitle: {
            type: String,
            default: 'Supprimer cet item'
        },
    },

    beforeMount()
    {
        if (isObject(this.answer))
        {
            this.$watch('answer.answer', (newVal, oldVal) =>
            {
                if (this.mounted == false || isNil(oldVal))
                {
                    return;
                }
                if (has(newVal, '$$disabledColums') && newVal['$$disabledColums'].length)
                {
                    forEach(newVal['$$disabledColums'], (col, index) =>
                    {
                        if (isObject(oldVal) && has(oldVal, '$$disabledColums') && !has(oldVal['$$disabledColums'], col))
                        {
                            this.$store.dispatch('CHANGE_2D_INCLUSIVE_DYN_PROP', [this.source, col, false, 0]);
                        }
                    });
                }
            });
        }

        this.$watch('disabled', (newVal, oldVal) =>
        {
            if (newVal === true && oldVal === false)
            {
                this.$store.dispatch('WIPE_ALL_2D_INCLUSIVE_DYN_ROW', [this.source]);
            }
        });
    },

    methods: {
        changeColumnValue(prop, state, rowID)
        {
            this.$store.dispatch('CHANGE_2D_INCLUSIVE_DYN_PROP', [this.source, prop, state, rowID]);
        },
        changeColumnLabel(label, rowID)
        {
            this.$store.dispatch('CHANGE_2D_INCLUSIVE_DYN_LABEL', [this.source, label, rowID]);
        },
        removeRow(rowID)
        {
            this.$store.dispatch('REMOVE_2D_INCLUSIVE_DYN_ROW', [this.source, rowID]);
        },
        addRow()
        {
            this.$store.dispatch('ADD_2D_INCLUSIVE_DYN_ROW', [this.source]);
        },

    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-2d-inclusive-dynamic-rows.vue